export default "__VITE_ASSET__Dwl4Q8rx__"